import { Duration } from 'luxon';

const formatScrollTime = (
  hours: number | undefined,
  minutes: number | undefined
): Duration => {
  const hour = hours !== undefined ? hours : 8;
  const min = minutes !== undefined ? minutes : 0;

  const hourString = /^\d$/.test(hour.toString()) ? `0${hour}` : `${hour}`;
  const minString = /^\d$/.test(min.toString()) ? `0${min}` : `${min}`;

  return Duration.fromISOTime(`${hourString}:${minString}:00`);
};

export default formatScrollTime;
